module.exports = __webpack_public_path__ + "static/img/empower6.9b177160.jpg";